<template>
  <div
    class="call-bar-container"
    :class="{ 'is-visible': isVisible }"
    @click="handleOpenCallWindow"
  >
    <v-icon size="24" :class="{ 'icon-visible': isVisible }">mdi-phone-ring</v-icon>
    <div class="call-bar-container__content" :class="{ 'content-visible': isVisible }">
      <span class="">Звонилкин Надоед Клиентович</span>
      <span class="">(01:32)</span>
    </div>
    <v-icon size="24" :class="{ 'icon-visible': isVisible }">
      {{ isVisible ? "mdi-window-minimize" : "mdi-window-maximize" }}
    </v-icon>
  </div>
</template>

<script setup>
import styles from '@/components/styleVariables'
import { useCallWindowStore } from '@/stores/callWindow'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const callWindowStore = useCallWindowStore()
const { windowState, isVisible } = storeToRefs(callWindowStore)

const cssStyles = computed(() => ({
  white: styles.colors.white,
  brandPrimary: styles.colors.brandPrimary,
}))

const handleOpenCallWindow = () => {
  if (windowState.value === 'open') {
    callWindowStore.toggleVisibility()
  }
  else {
    callWindowStore.openWindow()
  }
}
</script>

<style lang="scss" scoped>

.call-bar-container {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 400px;
  border: 1px solid rgb(var(--v-theme-brandPrimary));
  border-radius: 3px;
  padding: 10px;
  background-color: v-bind("cssStyles.brandPrimary");

  &.is-visible {
    background-color: transparent;
  }
  transition: opacity 0.3s ease;
  opacity: 1;

  &:hover{
    opacity: 0.8;
    cursor: pointer;
  }
}

.call-bar-container__content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 16px;
  line-height: 19px;
  font-weight: 700;
  color: v-bind("cssStyles.white");

  &.content-visible {
    color: v-bind("cssStyles.brandPrimary");
  }
}

.v-icon {
  color: v-bind("cssStyles.white");

  &.icon-visible {
    color: v-bind("cssStyles.brandPrimary");
  }
}

.collapse-icon {
  display: inline-block;
  width: 16px;
  height: 4px;
  background-color: rgb(var(--v-theme-brandPrimary));
}
</style>
